
import { Options } from "vue-class-component";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import ActionMenu from "../molecules/ActionMenu.vue";
import UserSelector from "../molecules/UserSelector.vue";
import PMAnalyticsChart from "../atoms/PMAnalyticsChart.vue";
import DepartmentUserSelector from "../organisms/DepartmentUserSelector.vue";
import { SelectableProfile, GetPMAnalytics, GetProfile } from "../../types";
import { StatsItemEnum, SystemApi } from "../../autogen";
import { print } from "../../helpers/view-utils";
import ChartViewMixin from "../../helpers/mixins/chart-view";
import Store from "../../store";
import { InstructionLevel } from "../../types";

@Options({
  components: {
    Page,
    ActionButton,
    UserSelector,
    DepartmentUserSelector,
    ActionMenu,
    PMAnalyticsChart
  }
})
export default class PMAnalytics extends ChartViewMixin {
  selectedUsers: SelectableProfile[] = [];
  stats: (GetPMAnalytics & GetProfile)[] = [];
  targetStats = StatsItemEnum.PmAnalytics;
  participantsMin = 1;
  participantsMax = 100;
  activePath = "main";
  departmentUserSelectorFormKey = 0;
  loadingFunction = true;
  tutorialImagePath = require("@/assets/image/PMTutorial.png");
  async onSelectionDone() {
    this.stats = this.selectedUsers.map(selectedUser =>
      Object.assign(this.chartData![selectedUser.id].profile, this.chartData![selectedUser.id].stats["PMAnalytics"], {
        id: selectedUser.id
      })
    );
  }
  onPrintButtonClick() {
    print(StatsItemEnum.PmAnalytics, this.stats);
  }
  async onCsvButtonClick() {
    if (this.selectedUsers.length === 0) {
      Store.getInstance().setInstructionContent(
        InstructionLevel.Confirm,
        `全データが出力されますが、よろしいですか？\nデータが多いと時間がかかる場合があります。`,
        async () => {
          try {
            this.downLoadCsvFile(StatsItemEnum.PmAnalytics, ["all"]);
          } catch (err) {
            Store.getInstance().setInstructionContent(
              InstructionLevel.Alert,
              "エラーが発生しました。時間を置いて再度試すか、窓口までお問い合わせください。"
            );
          }
        }
      );
    } else {
      const Employees = this.selectedUsers.map(user => user.id);
      this.downLoadCsvFile(StatsItemEnum.PmAnalytics, Employees);
    }
  }
  private async downLoadCsvFile(statType: StatsItemEnum, Employees: string[]) {
    Store.getInstance().setIsLoading(true);

    const encoding = require("encoding-japanese");
    try {
      const responseStatic = await new SystemApi().printCsv({
        type: statType,
        peopleIds: Employees
      });

      const str_array = encoding.stringToCode(responseStatic.data);
      const sjis_array = encoding.convert(str_array, "SJIS", "UNICODE");
      const uint8_array = new Uint8Array(sjis_array);

      const url = window.URL.createObjectURL(new Blob([uint8_array], { type: "text/csv;charset=Shift_JIS" }));
      const anchor = document.createElement("a");
      document.body.appendChild(anchor);
      anchor.setAttribute("href", url);
      anchor.setAttribute("download", `PM分析_${new Date().toISOString()}.csv`);
      anchor.click();
      anchor.remove();
      document.body.onfocus = null;
    } catch (err) {
      let errMessage = "エラーが発生しました。時間を置いて再度試すか、窓口までお問い合わせください。";
      if (err.response && err.response.data) {
        errMessage = err.response.data.detail;
      }
      Store.getInstance().setInstructionContent(InstructionLevel.Alert, errMessage);
    } finally {
      Store.getInstance().setIsLoading(false);
    }
  }
}
